<template>
	<div class="moneylist">
		<div class="btnbox">
			<el-button type="primary" size="small" @click="onexport()">账户明细导出</el-button>
		</div>
		<div class="tablebox">
			<div class="filterdiv filterty" ref="filter">
				<el-form :inline="true" :model="formfilter" class="demo-form-inline" size="small" label-width="0px" v-if="filtershow">
					<el-form-item label="">
						<el-select v-model="formfilter.ctype" placeholder="类型" size="small">
							<el-option label="类型" value=""></el-option>
							<el-option :label="v.name" :value="v.id" v-for="(v,k) in appdata.list.user_money_ctype" :key="k">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="">
						<el-date-picker v-model="formfilter.mydate" type="daterange" range-separator="至"
							start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd"
							value-format="yyyy-MM-dd">
						</el-date-picker>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="onfilter">查询</el-button>
						<el-button @click="onreset">重置</el-button>
					</el-form-item>
				</el-form>
			</div>
			<div class="zk" @click="filtershow=!filtershow ">
				<span>{{filtershow ? '收起':'展开'}}</span>
			</div>
			<div class="tablediv" ref="tablediv">
				<el-table :data="list" style="width: 100%" border height="100%">
					<el-table-column prop="ctype_str" label="类型" align="center" header-align="center">
					</el-table-column>
					<el-table-column prop="trade_no" label="订单编号" align="center" header-align="center">
					</el-table-column>
					<!-- <el-table-column prop="ctype_tag" label="增减类型" align="center" header-align="center">
					</el-table-column> -->
					<el-table-column prop="money" label="变化金额" align="center" header-align="center">
						<template slot-scope="scope">
							<div>{{scope.row.ctype_tag}}{{scope.row.money}}</div>
						</template>
					</el-table-column>
					<el-table-column prop="after_money" label="变化后余额" align="center" header-align="center">
					</el-table-column>
					<el-table-column prop="create_time_str" label="创建时间" align="center" header-align="center">
					</el-table-column>
				</el-table>
			</div>
			
			<div class="pagediv">
				<el-pagination background layout="prev, pager, next, sizes, total" :page-sizes="[20, 30, 50, 100, 200]" :current-page.sync="page" :page-size="pageSize"
					:total="total" v-if="total > 0" @current-change="handleCurrentChange" @size-change="handleSizeChange">
				</el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'Money',
		data() {
			return {
				list: [],
				page: 1,
				pageSize: 20,
				total: 0,

				formfilter: {
					ctype: "",
					mydate: [],
					btime: "",
					etime: "",
				},
				filtershow: true,
			}
		},

		inject: ['appdata', 'oncopy'],

		mounted() {
			this.onlist();
			this.resizeObserver = new ResizeObserver(entries => {
				for (let entry of entries) {
					const cr = entry.contentRect;
					var num = Number(cr.height)+30;
					this.$refs.tablediv.style.height = "calc(100% - "+num+"px)";
				}
			});
			this.resizeObserver.observe(this.$refs.filter);
		},
		
		beforeDestroy() {
			if (this.resizeObserver) {
				this.resizeObserver.disconnect();
			}
		},
		
		methods: {
			// 基础查询
			handleCurrentChange() {
				this.onlist();
			},
			
			handleSizeChange(val) {
				this.page = 1;
				this.pageSize = val;
				this.onlist();
			},
			
			onfilter() {
				this.page = 1;
				this.onlist();
			},
			
			onreset() {
				this.formfilter = {
					ctype: "",
					mydate: [],
					btime: "",
					etime: "",
				};
				this.page = 1;
				this.onlist();
			},
			
			
			onlist() {
				var obj = JSON.parse(JSON.stringify(this.formfilter));
				obj.btime = obj.mydate[0];
				obj.etime = obj.mydate[1];
				obj.page = this.page;
				obj.limit = this.pageSize;
				
				this.$axios.post('api/user/user_money_log_list', obj).then(res => {
					if (res.data.code == 0) {
						this.total = res.data.data.count;
						this.list = res.data.data.list;
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},
			
			onexport() {
				var obj = JSON.parse(JSON.stringify(this.formfilter));
				obj.btime = obj.mydate[0];
				obj.etime = obj.mydate[1];
				this.$axios.post('/api/user/user_money_log_export', obj).then(res => {
					if (res.data.code == 0) {
						this.$message.success('请前往任务中心-导出列表下载');
						this.$parent.oncount();
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},
		}
	}
</script>

<style scoped lang="less">
	.moneylist {
		height: 100%;
	}
	
	.tablebox {
		height: calc(100% - 104px);
	}
</style>



// WEBPACK FOOTER //
// src/components/buyer/money.vue